const getSelectedItems = (selected, data) => {
  if (data === null) return [];
  return selected.map(item => data[item]);
};

export default getSelectedItems;
